var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-redox-titration',{attrs:{"conc-oxalic-acid":_vm.concOxalicAcid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }